import { Button } from '@chakra-ui/react'
import { ExposureData } from '../../../../../types/FirestoreUser'

interface SaveButtonProps {
  isSaving: boolean
  onClick: (exposureData: ExposureData[], fieldName: string) => Promise<void>
  exposureData: ExposureData[]
  fieldName: string
}

const SaveButton = ({
  isSaving,
  onClick,
  exposureData,
  fieldName,
}: SaveButtonProps) => (
  <Button
    size="lg"
    isLoading={isSaving}
    onClick={() => onClick(exposureData, fieldName)}
  >
    Save
  </Button>
)

export default SaveButton